import React, { useEffect } from 'react';
import classnames from 'classnames';
import { Typography } from '@one-thd/sui-atomic-components';
import { useApplianceBundles } from './ApplianceBundlesProvider';
import { ItemPod, Buybox, Symbol } from './subcomponents';
import { ACCESSORY_GROUPS, INFO_DRAWERS, BUNDLE_TYPES } from '../constants';
// import '../styles/styles.scss';

export const ApplianceBundlesComponent = () => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('appliance-bundles.ready'); }, []);

  const {
    anchorItem,
    groupedBundleItems,
    accessoryItems,
    entireBundleHeading,
    accessoryHeading,
    bundleType,
    hasBundleItems,
    hasAccessoryItems,
    hasMobileView,
    hasTabletView
  } = useApplianceBundles();

  const getAccessoryProductGroup = () => {
    switch (bundleType) {
    case BUNDLE_TYPES.LAUNDRY:
      return ACCESSORY_GROUPS.LAUNDRY;
    case BUNDLE_TYPES.KITCHEN:
      return ACCESSORY_GROUPS.KITCHEN_ACCESSORIES;
    case BUNDLE_TYPES.DEFAULT:
    default:
      return '';
    }
  };

  const getAccessoryInfoDrawer = () => {
    switch (bundleType) {
    case BUNDLE_TYPES.LAUNDRY:
      return INFO_DRAWERS.LAUNDRY_ACCESSORIES;
    case BUNDLE_TYPES.KITCHEN:
      return INFO_DRAWERS.KITCHEN_ACCESSORIES;
    case BUNDLE_TYPES.DEFAULT:
    default:
      return {};
    }
  };

  const sortProducts = (unsortedProducts) => unsortedProducts
    .sort((primary, secondary) => primary.slot.order - secondary.slot.order);

  const bundleClassNames = classnames('sui-flex sui-flex-wrap sui-pt-6', {
    'sui-flex-col sui-pt-5 sui-max-w-sm': hasMobileView
  });

  const numSlots = Object.entries(groupedBundleItems).reduce((numAcc) => {
    // eslint-disable-next-line no-param-reassign
    numAcc += 1;
    return numAcc;
  }, hasAccessoryItems ? 2 : 1);

  const hasAnchorItem = !!anchorItem?.isAnchor;

  return (
    hasAnchorItem && (
      <div
        className="sui-w-auto sui-m-4"
        data-testid="appliance-bundle"
        data-component="ApplianceBundles"
      >
        <Typography
          key="entire-bundle-heading"
          variant="h2"
          data-testid="header"
        >
          {entireBundleHeading}
        </Typography>
        <div className={bundleClassNames} key="item-pods">
          <ItemPod
            key="pod-anchor"
            isAnchor
            products={[anchorItem]}
            productGroup={anchorItem?.category}
            heading="CURRENT ITEM"
            testId="anchor"
          />
          {hasBundleItems && (
            Object.keys(groupedBundleItems).map((productGroup) => {
              return (
                <>
                  <Symbol symbol="+" key={`symbol-${productGroup}`} />
                  <ItemPod
                    key={`pod-${productGroup}`}
                    products={sortProducts(groupedBundleItems[productGroup])}
                    productGroup={productGroup}
                    heading={`Matching ${productGroup}`}
                    drawerData={INFO_DRAWERS[productGroup]}
                    isDeclinable
                    testId={`bundle-${productGroup}`}
                  />
                </>
              );
            })
          )}
          {hasAccessoryItems && (
            <>
              <Symbol symbol="+" />
              <ItemPod
                key="pod-accessory"
                products={sortProducts(accessoryItems)}
                productGroup={getAccessoryProductGroup()}
                heading={accessoryHeading}
                drawerData={getAccessoryInfoDrawer()}
                isDeclinable
                testId="accessories"
              />
            </>
          )}
          {!(hasMobileView || hasTabletView)
              && (
                <>
                  <Symbol symbol="=" />
                  {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
                  <div className="sui-pt-[10rem]">
                    <Buybox />
                  </div>
                </>
              )}
        </div>
        {(hasMobileView || hasTabletView) && <div><Buybox /></div>}
      </div>
    )

  );
};

ApplianceBundlesComponent.displayName = 'ApplianceBundles';
